import { mainnet } from 'viem/chains';
import { reconnect } from 'wagmi/actions';
import { convertExtendedChain, isExtendedChain, } from './utils/convertExtendedChain.js';
export const syncWagmiConfig = async (wagmiConfig, connectors, chains) => {
    const _chains = chains.map((chain) => isExtendedChain(chain) ? convertExtendedChain(chain) : chain);
    const _mainnet = _chains.find((chain) => chain.id === mainnet.id);
    if (_mainnet) {
        _mainnet.contracts = { ...mainnet.contracts, ..._mainnet.contracts };
    }
    wagmiConfig._internal.chains.setState(_chains);
    wagmiConfig._internal.connectors.setState(() => [
        ...connectors,
        ...(wagmiConfig._internal.mipd
            ?.getProviders()
            .map(wagmiConfig._internal.connectors.providerDetailToConnector) ?? []),
    ].map(wagmiConfig._internal.connectors.setup));
    reconnect(wagmiConfig);
};
//# sourceMappingURL=syncWagmiConfig.js.map